import { render } from "./RegisterModal.vue?vue&type=template&id=edfe4d0c&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=edfe4d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfe4d0c"]])

export default __exports__